import { Field, ErrorMessage } from 'formik' 
import { AiOutlineExclamationCircle } from "react-icons/ai";

const BetaKeyInput = ({ errors, touched }) => {
  return (
    <>
        <label htmlFor='email'>Enter key</label>
        <Field 
            name="betaKey"
            type="password"
            placeholder="Enter your beta key"
            className={errors.email && touched.email ? "input-error" : ""}
        />
        <ErrorMessage name="betaKey">
            {msg => (
                <p className="error-msg">
                    <AiOutlineExclamationCircle />
                    <span>{msg}</span>
                </p>
            )}
        </ErrorMessage>
    </>
  )
}

export default BetaKeyInput